<div class="page">
    <div class="container-fluid">
        <div class="row page-header">
            <div class="col-md-8">
                <h3>Attendance - {{slot.subject}} &nbsp; <br>
                    <small>{{slot.batch.course.name}} ({{slot.batch.start_year}} - {{slot.batch.end_year}})</small> &nbsp;
                    <small>Year: {{slot.batch.current_semester}}</small>
                </h3>
                <p>
                    <small><strong>Slot Date:</strong> {{slot.slot_date | date:'fullDate'}}</small> &nbsp;
                    <small><strong>Time:</strong> {{slot.start_time}} - {{slot.end_time}}</small>
                </p>
                <p *ngIf="slot.faculty.name">
                    <small><strong>Faculty:</strong> {{slot.faculty.name}}</small>
                </p>
            </div>

            <div class="col-md-4 text-right">
                <span class="date-nav" (click)="backwardDate()">
                    &lt;
                </span>
                <input class="selected-date" [ngClass]="(formattedDate(date) == formattedDate(today)) ? 'today' : ''" 
                       type="date" value="{{formattedDate(date)}}" (change)="setCustomDate($event.target.value)"/>
                <span class="date-nav" (click)="forwardDate()" *ngIf="formattedDate(date) != formattedDate(today)">
                    &gt;
                </span>
                <span class="date-nav" *ngIf="formattedDate(date) == formattedDate(today)" style="visibility: hidden;">
                    
                </span>
            </div>
        </div>

        <div class="page-body">
            <!-- Session Type Toggle -->
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="session-type-selector">
                        <label class="mr-3"><strong>Session Type:</strong></label>
                        <button class="btn btn-sm" 
                                [ngClass]="sessionType === 'theory' ? 'btn-primary' : 'btn-outline-primary'"
                                (click)="setSessionType('theory')">
                            <i class="fa fa-book"></i> Theory
                        </button>
                        &nbsp;
                        <button class="btn btn-sm" 
                                [ngClass]="sessionType === 'practical' ? 'btn-primary' : 'btn-outline-primary'"
                                (click)="setSessionType('practical')">
                            <i class="fa fa-flask"></i> Practical
                        </button>
                    </div>
                </div>
            </div>

            <h4>Students ({{students.count}})</h4>

            <hr>

            <table class="table table-borderless table-striped">
                <thead>
                    <td>ID</td>
                    <td>Name</td>
                    <td style="width: 60%;">Attendance</td>
                </thead>

                <tbody>
                    <ng-container *ngIf="students.list.length > 0; else noData">
                        <tr *ngFor="let student of students.list">
                            <td>
                                <a href="javascript:void(0);" routerLink="/dashboard/student/{{student.id}}">{{student.student_id}}</a>
                            </td>
                            <td>
                                <a href="javascript:void(0);" routerLink="/dashboard/student/{{student.id}}">{{student.name}}</a>
                            </td>
                            
                            <td *ngIf="!isHoliday">
                                <button class="btn btn-sm" 
                                    [ngClass]="(!attendance[student.id] || attendance[student.id] == 1) ? 'btn-success' : 'btn-outline-dark'" 
                                    (click)="markAttendance(student.id, 1)">
                                    Present
                               </button>
                               &nbsp;

                                <button class="btn btn-sm"
                                    [ngClass]="(attendance[student.id] && attendance[student.id] == 2) ? 'btn-danger' : 'btn-outline-dark'"
                                    (click)="markAttendance(student.id, 2)">
                                    Absent
                               </button>
                            </td>

                            <td *ngIf="isHoliday">
                                <span class="badge badge-warning">HOLIDAY</span>
                            </td>
                        </tr>
                    </ng-container>
                    
                    <ng-template #noData>
                        <tr>
                           <td colspan="6" class="text-center">
                            No students added!
                           </td> 
                        </tr>
                    </ng-template>
                </tbody>

            </table>
            <div class="row" style="margin-bottom: 30px;">
                <div class="col-md-6">
                  <img src="assets/img/icon-arrow-left-active.svg" class="btn btn-nav" *ngIf="offset > 0" (click)="paginate(1)" />
                </div>
                <div class="col-md-6 text-right">
                  <img src="assets/img/icon-arrow-right-active.svg" class="btn btn-nav" *ngIf="students.count > offset+limit" (click)="paginate(2)" />
                </div>
            </div>

        </div>

    </div>
</div>
